import { CopyExchangeRateToAllBookingItem } from "./CopyExchangeRateToAllBookingItem";

export class CopyPurchaseNetPriceExchangeRateToAllBookingItemCommand extends CopyExchangeRateToAllBookingItem {
  CommandName = "CopyPurchaseNetPriceExchangeRateToAllBookingItem";

  constructor(
    sessionId: string,
    operationId: string,
    purchaseNetPriceCurrency: string,
    purchaseNetPriceExchangeDate: string | null,
    purchaseNetPriceExchangeRate: number | null
  ) {
    super(sessionId, operationId, purchaseNetPriceCurrency, purchaseNetPriceExchangeDate, purchaseNetPriceExchangeRate);
  }
}
